// Client-side file export helpers. The COP UI runs on a fixture data layer, so
// "Export" / "Download" actions generate a file from the in-memory data and
// trigger a browser download (the seam to /api/v1/cop/*/export later).

export function downloadFile(filename, content, type = 'application/json') {
	const blob = new Blob([content], { type });
	const url = URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	// Revoke on the next tick so the click has a chance to start the download.
	setTimeout(() => URL.revokeObjectURL(url), 0);
}

export function exportJson(filename, data) {
	downloadFile(filename, JSON.stringify(data, null, 2), 'application/json');
}

function csvCell(value) {
	if (value == null) return '';
	const str = String(value);
	return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}

// columns: [{ key, label }]
export function exportCsv(filename, rows, columns) {
	const header = columns.map((c) => csvCell(c.label)).join(',');
	const body = rows.map((row) => columns.map((c) => csvCell(row[c.key])).join(',')).join('\n');
	downloadFile(filename, `${header}\n${body}`, 'text/csv');
}

export function stamp() {
	return new Date().toISOString().slice(0, 10);
}
